import { Button } from '@/components/Button'
import { ButtonGroup } from '@/components/ButtonGroup'

export interface BreakerQuestionAnswerEditorProps {
  onBackPress?: () => unknown
  /**
   * Test ID attribute for the button group.
   */
  testId?: string
  /**
   * Test ID attribute for the back button.
   */
  backButtonTestId?: string
}

/**
 * Breaker question editor.
 */
export function BreakerQuestionAnswerEditor({
  onBackPress,
  testId,
  backButtonTestId,
}: BreakerQuestionAnswerEditorProps) {
  return (
    <ButtonGroup stretch stacked testId={testId}>
      <Button
        variant="outline"
        label="Go back"
        onPress={onBackPress}
        testId={backButtonTestId}
      />
    </ButtonGroup>
  )
}
